<div class="video-player-container">
    <video #videoEl autoplay playsinline webkit-playsinline width="100%" height="100%" [src]="videoUrl" controls
        controlsList="nodownload noremoteplayback" disablePictureInPicture disableRemotePlayback
        [class.locked]="preventForwardSeek"
        (timeupdate)="onTimeUpdate()" (seeking)="onSeeking()" (seeked)="onSeeked()" (ended)="onEnded()"
        (pause)="onPause()" (contextmenu)="$event.preventDefault()">
    </video>
    <div class="custom-controls" *ngIf="preventForwardSeek">
        <button type="button" class="ctrl-btn" (click)="rewind(10)">
            <i class="fa fa-undo"></i> Rewind 10s
        </button>
        <button type="button" class="ctrl-btn" (click)="restart()">
            <i class="fa fa-step-backward"></i> Restart
        </button>
    </div>
</div>
